var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-input-file is-flex is-centered" }, [
    _c("label", { staticClass: "label", attrs: { for: _vm.id } }, [
      _c("span", { staticClass: "title" }, [_vm._v(_vm._s(_vm.label))])
    ]),
    _c("input", {
      staticClass: "input",
      attrs: {
        type: "file",
        id: _vm.id,
        name: _vm.id,
        accept: _vm.accept,
        required: _vm.required,
        disabled: _vm.disabled
      },
      on: { input: _vm.onInput }
    }),
    _vm.value
      ? _c("img", { staticClass: "img", attrs: { src: _vm.url } })
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }